document.addEventListener('DOMContentLoaded', () => {
  const timerElements = document.querySelectorAll('.pdp-offer-timer');

  timerElements.forEach(timerElement => {
    const endDate = timerElement.dataset.endDate;
    const endTime = timerElement.dataset.endTime;

    if (!endDate || !endTime) {
      timerElement.style.display = 'none';
      return; // continue to next timerElement in forEach
    }

    // IMPORTANT: This assumes Denmark is on CEST (UTC+2).
    // This will be incorrect during winter when it's CET (UTC+1).
    // A robust solution requires a timezone library to handle DST automatically.
    const timezoneOffset = '+02:00';
    const targetTime = new Date(`${endDate}T${endTime}:00${timezoneOffset}`).getTime();

    if (isNaN(targetTime)) {
        timerElement.style.display = 'none';
        return;
    }

    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      if (distance < 0) {
        clearInterval(interval);
        const badge = timerElement.closest('offer-badge');
        if (badge) {
          badge.style.display = 'none';
        }
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      const format = (num) => num.toString().padStart(2, '0');

      timerElement.innerHTML = `${format(hours)}:${format(minutes)}:${format(seconds)}`;
    };

    const interval = setInterval(updateTimer, 1000);
    updateTimer();
  });
});
